import { useEffect, useState } from "react"
import * as React from "react"
import { PaginationType, ZoneType } from "@/types"
import { useQuery } from "@tanstack/react-query"
import { createFileRoute, Link, redirect } from "@tanstack/react-router"
import { useReactToPrint, UseReactToPrintFn } from "react-to-print"

import { canViewThisPage } from "@/lib/api/auth"
import { getZones } from "@/lib/api/billing"
import { Button, buttonVariants } from "@/components/ui/button"
import { DataTable } from "@/components/data-table"
import { Header } from "@/components/header"
import { Icons } from "@/components/icons"
import { zonesColumns } from "@/components/table/columns/zones-columns"
import { ExportOperationModal } from "@/components/table/operations/export-operations"

import AddZonesPage from "./add"

export const Route = createFileRoute("/_home/zone-settings/zones/")({
  beforeLoad: () => {
    if (canViewThisPage("himo_billing.view_zone")) {
      return
    }

    return redirect({ to: "/access-denied" })
  },
  component: ZonesPage,
})

function ZonesPage() {
  const [defaultPage, setDefaultPage] = useState<number>(10)
  const [page, setPage] = useState<number>(1)
  const [search, setSearch] = useState<string>("")
  const [showExportModal, setShowExportModal] = React.useState<boolean>(false)
  const [nextPageUrl, setNextPageUrl] = useState<string | null>(null)
  const [prevPageUrl, setPrevPageUrl] = useState<string | null>(null)

  const {
    data: zonesDetails,
    isError,
    isLoading,
  } = useQuery<PaginationType<ZoneType>>({
    queryKey: ["zonesDetails", defaultPage, page, search],
    queryFn: () => getZones(defaultPage, page, search),
  })

  useEffect(() => {
    if (zonesDetails) {
      setNextPageUrl(zonesDetails.next)
      setPrevPageUrl(zonesDetails.previous)
    }
  }, [zonesDetails])

  const contentRef = React.useRef<HTMLDivElement>(null)
  const reactToPrintFn = useReactToPrint({ contentRef })

  return (
    <div className="space-y-4 p-4">
      <Header>Zones</Header>
      <div ref={contentRef} className="print:p-2">
        <DataTable
          columns={zonesColumns}
          data={zonesDetails?.results ?? []}
          search={{
            label: "Zones",
            value: search,
            onChange: setSearch,
          }}
          //tableTitle="Zones"
          isLoading={isLoading}
          isError={isError}
          defaultPage={defaultPage}
          setDefaultPage={setDefaultPage}
          nextPageUrl={nextPageUrl}
          prevPageUrl={prevPageUrl}
          page={page}
          setPage={setPage}
          totalCount={zonesDetails?.count}
        >
          <div className="flex w-full justify-end">
            <AddZonesPage />
            <Button className="mx-1" onClick={(e) => reactToPrintFn()}>
              <Icons.download />
              Print Zone
            </Button>
            <ExportOperationModal
              tableData={zonesDetails?.results ?? [{}]}
              fileName="Zones"
              showExportModal={showExportModal}
              setShowExportModal={setShowExportModal}
            />
          </div>
        </DataTable>
      </div>
    </div>
  )
}
